import React, { useRef, memo } from 'react';
import { NOT_FOUND } from 'redux-first-router';
import { connect } from 'react-redux';
import UniversalComponent from './UniversalComponent';
import ErrorBoundary from '../hocs/ErrorBoundary/ErrorBoundary';
import { addClass, removeClass } from '../utils/dom';
import { getCurrentPath, pageComponents } from '../utils/resolvePage';

const areEqual = (prevProps, { pageStatus, location, pageData, properties, setup, productCache = {} }) => {
	if (pageStatus.loading) addClass(document.body, 'is_pageLoading');
	if (pageStatus.loading || properties.siteInitiated === false) return true;

	const currentPath = getCurrentPath(setup, location.pathname, location.type);
	const data = pageData[currentPath];
	const staticPages = ['receipt', 'selection/receipt', 'selection/receipt/debug', 'search', 'selection', 'account'];

	// Check if all data is available.
	if ((!pageData || !data) && staticPages.indexOf(pageStatus.pageType) === -1) return true;
	// Here we want to intercept "CatchAll" and read path API data to know which page to load.
	if (pageStatus.pageType === 'category' && Object.keys(productCache).length === 0) return true;

	if (pageStatus.pageType !== 'category') window.scrollTo(0, 0);
	removeClass(document.body, 'is_pageLoading');

	return false;
};

const Page = ({ setup, pathname, type, pageStatus, pageData, missingPage }) => {
	const currentPath = getCurrentPath(setup, pathname, type);
	const data = type === NOT_FOUND ? { content: missingPage } : pageData[currentPath];
	let page = data?.pageType || pageStatus?.pageType;
	if (type === 'START') page = 'start';

	const parentContainer = useRef(null);

	return (
		<div ref={parentContainer}>
			{ pageComponents[page] && <UniversalComponent page={pageComponents[page]} pageType={page} data={data} currentPath={currentPath} /> }
		</div>
	);
};

const Switcher = ({ pageStatus, location, ...props }) => {
	if (pageStatus.loading) return true;
	return (
		<ErrorBoundary message="Error in Switcher">
			<Page pathname={location.pathname} type={location.type} pageStatus={pageStatus} {...props} />
		</ErrorBoundary>
	);
};

const mapState = ({ pageStatus, location, pageData, environment, productCache }) => ({
	pageStatus,
	location,
	pageData,
	properties: environment.properties,
	setup: environment.setup,
	missingPage: environment.missingPage,
	productCache,
});

export default connect(mapState)(memo(Switcher, areEqual));
